import StorageService from 'services/StorageService/'
import Cookies from 'universal-cookie';
import Day from 'dayjs';

const cookies = new Cookies();

const getSalesChannel = () => {
    return StorageService.getSecureItem('sales_channel') || cookies.get('store-sale-channel') || 11;
}

const setSalesChannel = (sc)  => {
    const expDate = Day().day(30).toDate();

    StorageService.setSecureItem('sales_channel', sc);
    cookies.set('store-sale-channel', sc, { path: '/', expires: expDate, secure: !PROJECT_ENV.authDevelopment});
}

const getSalesChannelName = () => {
    return StorageService.getItem('store_name') || cookies.get('store-name') || 'Jumbo Chile';
}

const setSalesChannelName = (name) => {
    const expDate = Day().day(30).toDate();

    cookies.set('store-name', name, { path: '/', expires: expDate, secure: !PROJECT_ENV.authDevelopment});
    StorageService.setItem('store_name', name);
}

const getMethodName = (sellerId = false) => {
    if(!sellerId)
        return StorageService.getItem('preselected_shipping_method') || cookies.get('preselected-shipping-method') || 'Jumbo Chile';
    else{
        let preselected = StorageService.getItem('preselected_shipping_method_split');

        if(preselected){
            preselected = JSON.parse(preselected);
            return preselected[sellerId];
        }else{
            return ''
        }
        
    }
}



const setMethodName = (method, sellerId = false) => {
    if(!sellerId || sellerId == '1'){
        const expDate = Day().day(30).toDate();
        cookies.set('preselected-shipping-method', method, { path: '/', expires: expDate, secure: !PROJECT_ENV.authDevelopment});
        StorageService.setItem('preselected_shipping_method', method);
    }

    let preselectedSplit = StorageService.getItem('preselected_shipping_method_split');
    let newMethod = preselectedSplit ? JSON.parse(preselectedSplit) : {};
    newMethod[sellerId ? sellerId : '1'] = method;
    StorageService.setItem('preselected_shipping_method_split',JSON.stringify(newMethod));
}

const setOldSalesChannelInfo = () => {
    const salesChannel = SalesChannel.getSalesChannel();
    const salesChannelName = SalesChannel.getSalesChannelName();
    const methodName = SalesChannel.getMethodName();

    StorageService.setItem('old_sales_channel_info', JSON.stringify({
        salesChannel,
        salesChannelName,
        methodName
    }));
}

const getOldSalesChannelInfo = () => {
    const info = StorageService.getItem('old_sales_channel_info');
    return info ? JSON.parse(info) : {};
}

const removeAll = () => {
    //Remove cookies nuevo.jumbo.cl
    cookies.remove('preselected-shipping-method', { path: '/', domain: 'nuevo.jumbo.cl' });
    cookies.remove('store-name', { path: '/', domain: 'nuevo.jumbo.cl' });
    cookies.remove('store-sale-channel', { path: '/', domain: 'nuevo.jumbo.cl' });
    //Remove cookies checkout.jumbo.cl
    cookies.remove('preselected-shipping-method', { path: '/', domain: 'checkout.jumbo.cl' });
    cookies.remove('store-name', { path: '/', domain: 'checkout.jumbo.cl' });
    cookies.remove('store-sale-channel', { path: '/', domain: 'checkout.jumbo.cl' });

    cookies.remove('preselected-shipping-method');
    cookies.remove('store-name');
    cookies.remove('store-sale-channel');
}

const SalesChannel = {
    removeAll,
    getOldSalesChannelInfo,
    setOldSalesChannelInfo,
    setMethodName,
    getMethodName,
    setSalesChannelName,
    getSalesChannelName,
    setSalesChannel,
    getSalesChannel
}

export default SalesChannel;
